import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
/** Renders the per-category counts, e.g. "marks N voters as voted via other
 * channels, disables M voters, updates K profiles, adds J voters" from the
 * reconciliation confirmation dialog acceptance criteria. */
export var CategorySummary = function (_a) {
    var counts = _a.counts, highlighted = _a.highlighted;
    var t = useTranslation().t;
    var entries = Object.entries(counts).filter(function (_a) {
        var count = _a[1];
        return (count !== null && count !== void 0 ? count : 0) > 0;
    });
    return (_jsx(Stack, { direction: "row", gap: 1, flexWrap: "wrap", children: entries.map(function (_a) {
            var category = _a[0], count = _a[1];
            return (_jsxs(Box, { sx: {
                    border: "1px solid",
                    borderColor: (highlighted === null || highlighted === void 0 ? void 0 : highlighted.has(category)) ? "warning.main" : "divider",
                    borderRadius: 1,
                    px: 1.5,
                    py: 1,
                }, children: [_jsx(Typography, { variant: "caption", color: "text.secondary", children: t("reconciliation.categories.".concat(category), category) }), _jsx(Typography, { variant: "h6", children: count })] }, category));
        }) }));
};
export default CategorySummary;
